import TWEEN from "@tweenjs/tween.js";

export const tweenAnimations = (objInnit, objTo, durations, updateCallback) => {
    return new TWEEN.Tween(objInnit)
        .to(objTo, durations)
        .onUpdate(obj => {
            updateCallback(obj)
        })
}